<template>
    <li class="menu-item" :class="{ 'menu-item-active': isActive(routeName) }">
        <a :href="url" class="menu-link" :target="targetBlank ?  '_blank' : '' ">
        <span class="svg-icon menu-icon"><i class="menu-bullet menu-bullet-line"><span></span></i></span>
        <span class="menu-text">{{ label }}</span>

        <span class="menu-label" v-if="badge">
            <span class="label label-rounded label-primary">{{ badge }}</span>
        </span>

        </a>
    </li>
</template>

<script>

export default {
    props: {
        label: String,
        url: String,
        routeName: String,
        badge: String,
        targetBlank: Boolean,
    },
    methods: {
        isActive(routeName) {
            return this.$route().current() === routeName;
        },
    },
}
</script>
